import { Property } from 'csstype'

import { Padding, TextStyling } from '@thg-commerce/gravity-theme'

export enum ProgressIndicatorType {
  CIRCULAR = 'circular',
  BAR = 'bar',
}

export enum CircularIndicatorType {
  FULL = 'full-circle',
  SEMI = 'semi-circle',
}

export enum BarIndicatorPosition {
  FIXED = 'fixed',
  UNSET = 'unset',
}

export type ProgressIndicatorStyle = {
  title: {
    font: TextStyling
  }
  currentCountText: {
    font: TextStyling
  }
  itemsText: {
    font: TextStyling
  }
  circularIndicator: {
    shape: CircularIndicatorType
    width?: number
    height?: number
    padding: Padding
    border?: {
      width?: string
      style?: string
      color?: Property.Color
    }
  }
  barIndicator: {
    position: BarIndicatorPosition
    containerHeight?: string | number
    barHeight?: number
    padding: Padding
    backgroundColor?: Property.Color
  }
}
